export default "__VITE_ASSET__D0BPKO7r__"